import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';

@Component({
    selector: 'dialog3-template',
    templateUrl: 'dialog3-template.html',
    styleUrls: ['dialog3-template.scss']
})
export class Dialog3Template implements OnInit {
    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<Dialog3Template>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,

    ) {
        if(data){
            this.header = data;
        }
    }

    ngOnInit() {
       
    }
   
}
